<script setup>
import { useRoute, useRouter } from "vue-router";
import CarRentalAvailForm from "@/views/v2/sales/carrental/items/form/availability/CarRentalAvailForm.vue";
import { onMounted, onUnmounted, ref, watch } from "vue";
import { CarRentalItemsSortFormModel } from "@/formmodel/sales/carrental/availablility/carRentalItemsSortFormModel";
import { CarRentalItemsFilterFormModel } from "@/formmodel/sales/carrental/availablility/carRentalItemsFilterFormModel";
import dateUtils from "@/utils/dateUtils";
import { useCarRentalAvailabilityStore } from "@/stores/v2/carrental/availablility/carRentalAvailabilityStore";
import { Drawer, Empty, Spin } from "ant-design-vue";
import CarRentalItem from "@/views/v2/sales/carrental/items/group/CarRentalItem.vue";
import CarRentalResultsSortAndFilterForm from "@/views/v2/sales/carrental/items/form/availability/CarRentalResultsSortAndFilterForm.vue";
import { useCmsContentStore } from "@/stores/cms";
import { useTemplateStore } from "@/stores/template";
import CarRentalMobileItem from "@/views/v2/sales/carrental/items/group/CarRentalMobileItem.vue";

const AEmpty = Empty;
const ADrawer = Drawer;

const router = useRouter();
const route = useRoute();
const carRentalAvailStore = useCarRentalAvailabilityStore();
const templateStore = useTemplateStore();

const carRentalItemsShowRef = ref([]);
const currentPageRef = ref(1); //每次load more添加一页显示
const isLoadMoreRef = ref(true);
const daysApartRef = ref(1); //租期
const carRentalAvailFormModelRef = ref(null);

const carRentalSearchFormShowRef = ref(false);

//region 设备识别
const equipmentType = ref(templateStore.responsive.equipmentType);
watch(
  () => templateStore.responsive.equipmentType,
  (newValue) => {
    equipmentType.value = newValue;

    carRentalSearchFormShowRef.value = equipmentType.value !== "iphone";
  },
  { immediate: true }
);
//endregion 设备识别

watch(
  () => carRentalAvailStore.carRentalItemsShow,
  (newValue) => {
    carRentalSearchFormShowRef.value = false;
    if (newValue) {
      carRentalItemsShowRef.value = newValue;
    } else {
      carRentalItemsShowRef.value = [];
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => carRentalAvailStore.carRentalAvailFormModel,
  (newValue) => {
    carRentalAvailFormModelRef.value = newValue;

    if (newValue) {
      let pickUpDateTime = newValue.pickupDateTime;
      let returnDateTime = newValue.returnDateTime;

      daysApartRef.value = dateUtils.getDaysByDateRange(
        pickUpDateTime,
        returnDateTime
      );
    }
  },
  { immediate: true, deep: true }
);

//过滤排序相关
const carRentalItemsSortFormModelRef = ref(
  new CarRentalItemsSortFormModel("PRICE", "ASC")
);
const carRentalItemsFilterFormModelRef = ref(
  new CarRentalItemsFilterFormModel("", [], [])
);

//过滤排序总入口
function sortAndFilter(sortFormModel, filterFormModel) {
  carRentalAvailStore.changeCarRentalItemsShow(
    null,
    null,
    filterFormModel,
    sortFormModel
  );
}

//endregion

//region 辅助函数

//-------------酒店数据滑动到底部自动加载---------------------
onMounted(() => {
  window.addEventListener("scroll", handleScroll, { passive: true });
});

function handleScroll() {
  /*
   * document.documentElement.scrollHeight:
   * document.documentElement.scrollTop
   * document.documentElement.clientHeight
   * */
  const scrollContainer = document.scrollingElement || document.documentElement;
  const distance =
    scrollContainer.scrollHeight -
    scrollContainer.scrollTop -
    scrollContainer.clientHeight;
  if (distance > -20 && distance < 100) {
    loadMoreItems();
  }
}

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

function loadMoreItems() {
  if (carRentalItemsShowRef.value.length >= carRentalAvailStore.totalResult) {
    isLoadMoreRef.value = false;
  }
  currentPageRef.value += 1;
  carRentalAvailStore.changeCarRentalItemsShow(currentPageRef.value, true);
}

//------------酒店数据滑动到底部自动加载-----------------------

function selectVehicle(carClassCode) {
  const query = route.query;
  query.preferredCarType = carClassCode;
  const routeUrl = router.resolve({
    name: "sales-carrental-extras-v2",
    query: query,
  });
  window.open(routeUrl.href, "_blank");

  // router.push({ name: "sales-carrental-extras-v2", query: query });
}

//endregion

//region cms内容管理
const cmsContentStore = useCmsContentStore();
cmsContentStore.getProductBannerBackground();
const baseUrl = "/api/v3/content/collections/images";
let imageUrl = ref("");
let backgroundImageUrl = ref("");

watch(
  () => cmsContentStore.productPageBackgroundImage,
  (newValue) => {
    imageUrl.value =
      cmsContentStore.productPageBackgroundImage &&
      cmsContentStore.productPageBackgroundImage.CarRentalBackgroundImage
        ? cmsContentStore.productPageBackgroundImage.CarRentalBackgroundImage
            .url
        : "";
    backgroundImageUrl.value = baseUrl + imageUrl.value;
  },
  { immediate: true, deep: true }
);
//endregion cms内容管理

let filterOpenRef = ref(false);
const showFilterDrawer = () => {
  filterOpenRef.value = true;
};
const closeFilterDrawer = () => {
  filterOpenRef.value = false;
};
</script>

<template>
  <!--   Banner Area -->
  <section
    id="page_banner"
    :style="{
      backgroundImage: 'url(' + backgroundImageUrl + ')',
    }"
  >
    <div class="container">
      <div class="common_banner_text">
        <h2>Car Rental List</h2>
        <ul>
          <li class="pre-page" @click="router.push({ name: 'home' })">
            {{ $t("home") }}
          </li>

          <li>
            <i class="fas fa-circle"></i>
            Car Rental List
          </li>
        </ul>
      </div>
    </div>
  </section>
  <!--   Banner Area  END-->

  <section id="theme_search_form_tour">
    <div class="container">
      <div
        v-if="carRentalAvailFormModelRef && equipmentType === 'iphone'"
        class="row"
      >
        <div class="col-10">
          <div class="font-18 font_weight">
            <span v-if="!carRentalAvailFormModelRef.returnLocation">{{
              carRentalAvailFormModelRef.pickupLocationName
            }}</span
            ><span v-else
              >{{ carRentalAvailFormModelRef.pickupLocationName }} -
              {{ carRentalAvailFormModelRef.returnLocationName }}</span
            >
          </div>
          <div class="text-muted">
            {{
              carRentalAvailFormModelRef.pickupDateTime
                ? dateUtils.formatDateTime(
                    carRentalAvailFormModelRef.pickupDateTime
                  )
                : ""
            }}
            -
            {{
              carRentalAvailFormModelRef.returnDateTime
                ? dateUtils.formatDateTime(
                    carRentalAvailFormModelRef.returnDateTime
                  )
                : ""
            }}
          </div>
        </div>
        <div
          class="col-2 link-info font-18"
          @click="carRentalSearchFormShowRef = !carRentalSearchFormShowRef"
        >
          {{ $t("edit") }}
        </div>
      </div>
      <div v-show="carRentalSearchFormShowRef || equipmentType !== 'iphone'">
        <!--搜索表单 -->
        <CarRentalAvailForm
          :equipment-type="equipmentType"
          :jumboable="false"
        />
        <!--搜索表单-->
      </div>

      <div v-if="equipmentType === 'iphone'" class="mg-t-10 mg-b-10">
        <hr class="mg-t-10" />
        <div class="flex flex-between">
          <h4>
            {{
              $t("vehicle-num", {
                carRentalItemsLength: carRentalAvailStore.carRentalItems
                  ? carRentalAvailStore.carRentalItems.length
                  : 0,
              })
            }}
          </h4>
          <h4 class="text-muted" @click="showFilterDrawer">
            {{ $t("filter-and-sort") }}<i class="fa fa-fw fa-angle-down"></i>
          </h4>
        </div>
        <a-drawer
          :open="filterOpenRef"
          placement="bottom"
          title="Filter Option"
          @close="closeFilterDrawer"
        >
          <CarRentalResultsSortAndFilterForm
            :car-rental-filter-form-model="carRentalItemsFilterFormModelRef"
            :car-rental-items-length="
              carRentalAvailStore.carRentalItems
                ? carRentalAvailStore.carRentalItems.length
                : 0
            "
            :car-rental-sort-form-model="carRentalItemsSortFormModelRef"
            :equipment-type="equipmentType"
            @sortAndFilter="sortAndFilter"
          />
        </a-drawer>
      </div>
    </div>
  </section>

  <section class="section_padding">
    <div class="container">
      <div class="row">
        <div v-if="equipmentType !== 'iphone'" class="col-3">
          <CarRentalResultsSortAndFilterForm
            :car-rental-filter-form-model="carRentalItemsFilterFormModelRef"
            :car-rental-items-length="
              carRentalAvailStore.carRentalItems
                ? carRentalAvailStore.carRentalItems.length
                : 0
            "
            :car-rental-sort-form-model="carRentalItemsSortFormModelRef"
            @sortAndFilter="sortAndFilter"
          />
        </div>

        <div :class="{ 'col-12': equipmentType === 'iphone' }" class="col-9">
          <div
            v-if="carRentalItemsShowRef && carRentalItemsShowRef.length > 0"
            class="row"
          >
            <div
              v-for="(
                carRentalItem, carRentalItemIndex
              ) in carRentalItemsShowRef"
              :key="carRentalItemIndex"
            >
              <CarRentalItem
                v-if="equipmentType !== 'iphone'"
                :car-rental-item="carRentalItem"
                :car-rental-item-index="carRentalItemIndex"
                :days-apart="daysApartRef"
                @selectVehicle="selectVehicle"
              />
              <CarRentalMobileItem
                v-else
                :car-rental-item="carRentalItem"
                :car-rental-item-index="carRentalItemIndex"
                :days-apart="daysApartRef"
                @selectVehicle="selectVehicle"
              />
            </div>
            <div
              v-if="
                isLoadMoreRef &&
                carRentalAvailStore.carRentalItems &&
                carRentalAvailStore.carRentalItems.length > 0 &&
                carRentalAvailStore.carRentalItems.length >
                  carRentalAvailStore.limit &&
                carRentalItemsShowRef > carRentalAvailStore.limit
              "
              class="text-center"
            >
              <Spin></Spin>
              <span class="mg-l-8 text-primary">{{ $t("load-more") }}..</span>
            </div>
          </div>
          <div v-else>
            <AEmpty></AEmpty>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
